import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import {UserService} from '../services/user.service';
import {UrlService} from '../../../../services/url.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {UserRole} from '../../../../types/admin-data.types';

declare const swal;
declare const toastr;

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class UserModalComponent implements OnInit {
    @Input() modalType: 'edit' | 'create' | 'toStaff';
    @Input() itemData;
    @Output() onClose = new EventEmitter();
    @ViewChild('form') form;
    modalTitle = {
        edit: 'Edit User Details',
        create: 'New User Details',
        toStaff: 'Resident to Staff'
    };
    public disabledSubmit = false;
    public title: string;
    public userRolesList: Array<any> = [];
    public buildingPropertyManager: Array<any> = [];
    public corporationNumberPropertyManager: Array<any> = [];
    public userTypes = [
        {id: 'super_admin', name: 'Super Admin'},
        {id: 'company_admin', name: 'Company Admin'},
        {id: 'property_manager', name: 'Staff'},
    ];
    public isSuperAdmin: boolean = false;
    private isFormDirty = false;
    private originalPhones = [];
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Properties',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        maxHeight: 150,
        enableSearchFilter: true
    };
    step = 'details';

    constructor(public urlService: UrlService,
                public userService: UserService,
                public api: ApiClientService) {
    }

    ngOnInit() {
        this.title = this.modalTitle[this.modalType] || this.modalTitle['create'];
        this.userRolesList.push({
            role: null,
            properties: [],
            corporationNumberId: null,
            userRoles: [],
            multiselectBuildings: [],
            propertyFilter: {}
        });
        if (this.itemData.phones)
            this.originalPhones = JSON.parse(JSON.stringify(this.itemData.phones));
        this.userService.getBuildings().subscribe(
            res => {
            },
            err => {
            },
            () => {
                // this.getCurrentAccountType();
                this.setUserRoleData();
            }
        );
        this.getCurrentAccountType();
        this.urlService.modalOpened.emit();
    }

    setUserRoleData() {
        this.userService.multiselectBuildings.forEach(item => item.disabled = false);
        if (this.itemData.buildingPropertyManager) {
            this.itemData.buildingPropertyManager.forEach(item => {
                const existedRoleItem = this.userRolesList.find(roleItem => {
                    return !roleItem.role && !item.role || Number(roleItem.role) === Number(item.role && item.role.id);
                });
                const currentBuilding = this.userService.multiselectBuildings.find(building => Number(building.id) === Number(item.buildingId)) || {};
                currentBuilding.disabled = true;

                if (existedRoleItem) {
                    existedRoleItem.properties.push({
                        id: currentBuilding.id,
                        itemName: currentBuilding.name,
                        disabled: true
                    });
                } else {
                    const userRoles = this.filterRoles(item.role.corporationNumberId);
                    const userRole = userRoles.find(r => r.id == item.role.id);
                    const selectedCorporation = this.userService.corporationNumberListForSearchSelect.find(c => c.value == item.role.corporationNumberId) || {};
                    this.userRolesList.push({
                        role: item.role && item.role.id,
                        properties: [{
                            id: currentBuilding.id,
                            itemName: currentBuilding.name,
                            disabled: true
                        }],
                        multiselectBuildings: item.role && item.role.corporationNumberId ?
                            this.userService.multiselectBuildings.filter(b => b.corporationNumber == item.role.corporationNumberId && !b.disabled)
                            : [],
                        corporationNumberId: item.role && item.role.corporationNumberId,
                        userRoles: userRoles,
                        propertyFilter: {corporationNumberId: item.role.corporationNumberId},
                        corporationName: selectedCorporation.optionText,
                        roleName: userRole ? userRole.name : ''
                    });
                }
            });
        }
        this.onPropertySelect();
    }

    close() {
        if (this.isFormDirty) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.resetPhones(this.originalPhones);
                    this.onClose.emit();
                }
            );
        } else {
            this.resetPhones(this.originalPhones);
            this.onClose.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (this.modalType !== 'toStaff') {
            if (form.invalid) return toastr.error('You should fill required fields');
            if (!this.validateEmail(this.itemData.email)) {
                toastr.warning('Email is not in valid format.');
                return;
            }
            if (this.itemData.userType != 'super_admin' && !this.allUserRoleDetailsAreFilled())
                return toastr.error('You should fill all user role details');
            if (this.userRolesList.length < 2 && form.value.userType == 'property_manager') {
                toastr.warning('User Roles list must not be empty.');
                return;
            }
            this.disabledSubmit = true;
            this.submitUserData(this.itemData);
        }
        if (this.modalType === 'toStaff') {
            if (!this.allUserRoleDetailsAreFilled()) {
                return toastr.error('You should fill all user role details');
            }
            if (this.userRolesList.length < 2 && form.value.userType == 'property_manager') {
                toastr.warning('User Roles list must not be empty.');
                return;
            }
            this.disabledSubmit = true;
            this.submitResidentToStaffRequest(this.itemData);
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
    }

    submitUserData(data): void {
        const newUserData: any = {};
        newUserData.fullName = this.itemData.fullName;
        newUserData.username = this.itemData.email;
        newUserData.email = this.itemData.email;
        if (data.userType == 'property_manager' || data.company || this.itemData.company) {
            newUserData.company = this.itemData.company;
            newUserData.company = (typeof this.itemData.company === 'object') ? newUserData.company.id : newUserData.company;
        }
        newUserData.phones = this.itemData.phones ? this.itemData.phones.map(item => {
            if (item.id) delete item.id;
            return item;
        }) : [];
        newUserData.userType = this.itemData.userType || 'property_manager';

        this.userRolesList.forEach((item, index) => {
            if (index != 0) {
                const corporationNumberItem = this.userService.corporationNumberList.find(corp => Number(corp.id) === Number(item.corporationNumberId)) || {};
                if (item.properties.length) {
                    item.properties.forEach(prop => {
                        this.buildingPropertyManager.push({
                            buildingId: prop.id,
                            role: item.role
                        });

                        this.corporationNumberPropertyManager.push({
                            corporationNumberBdId: item.corporationNumberId,
                            corporationNumber: corporationNumberItem.name
                        });
                    });
                }
            }
        });
        newUserData.buildingPropertyManager = this.buildingPropertyManager;
        newUserData.corporationNumberPropertyManager = this.corporationNumberPropertyManager;
        if (this.modalType !== 'edit')
            newUserData.sendInvitationEmail = this.itemData.sendInvitationEmail ? 1 : 0;

        if (this.modalType === 'edit') {
            this.userService.update(this.itemData.id, newUserData).subscribe(res => {
                this.userService.get();
                this.onClose.emit();
                toastr.success('User successfully updated.');
            }, err => {
                this.api.errorHandler(err);
                try {
                    const body = JSON.parse(err._body);
                    const errorFields = Object.keys(body.fields);
                    errorFields.forEach(field => {
                        toastr.error(body.fields[field].errors[0].description);
                    });
                    this.disabledSubmit = false;
                } catch (err) {
                    toastr.error('User update failed.');
                    this.disabledSubmit = false;
                }
            });
        } else {
            this.userService.create(newUserData).subscribe((res) => {
                this.userService.get();
                this.onClose.emit();
                toastr.success('User successfully created.');
                if (this.itemData.sendInvitationEmail)
                    toastr.success('Confirmation mail was successfully sent to the specified email.');
            }, err => {
                this.api.errorHandler(err);
                try {
                    const body = JSON.parse(err._body);
                    const errorFields = Object.keys(body.fields);
                    errorFields.forEach(field => toastr.error(body.fields[field].errors[0].description));
                    this.disabledSubmit = false;
                } catch (err) {
                    toastr.error('User create failed.');
                    this.disabledSubmit = false;
                }
            });
        }
    }

    submitResidentToStaffRequest(data) {
        const newUserData: any = {};
        if (data.userType == 'property_manager' || data.company || this.itemData.company) {
            newUserData.company = this.itemData.company;
            newUserData.company = (typeof this.itemData.company === 'object') ? newUserData.company.id : newUserData.company;
        }
        newUserData.userType = 'property_manager';

        this.userRolesList.forEach((item, index) => {
            if (index != 0) {
                const corporationNumberItem = this.userService.corporationNumberList.find(corp => Number(corp.id) === Number(item.corporationNumberId)) || {};
                if (item.properties.length) {
                    item.properties.forEach(prop => {
                        this.buildingPropertyManager.push({
                            buildingId: prop.id,
                            role: item.role
                        });

                        this.corporationNumberPropertyManager.push({
                            corporationNumberBdId: item.corporationNumberId,
                            corporationNumber: corporationNumberItem.name
                        });
                    });
                }
            }
        });
        newUserData.buildingPropertyManager = this.buildingPropertyManager;
        newUserData.corporationNumberPropertyManager = this.corporationNumberPropertyManager;
        this.userService.update(this.itemData.id, newUserData).subscribe(res => {
            this.userService.get();
            this.onClose.emit();
            toastr.success('User successfully updated.');
        }, err => {
            this.api.errorHandler(err);
            try {
                const body = JSON.parse(err._body);
                const errorFields = Object.keys(body.fields);
                errorFields.forEach(field => {
                    toastr.error(body.fields[field].errors[0].description);
                });
                this.disabledSubmit = false;
            } catch (err) {
                toastr.error('User convert successfully!');
                this.disabledSubmit = false;
            }
        });
    }

    public addNewRole(): void {
        if (!(this.userRolesList[0].corporationNumberId === null || this.userRolesList[0].role === null ||
            !this.userRolesList[0].userRoles || this.userRolesList[0].userRoles.length < 1 ||
            !this.userRolesList[0].properties || this.userRolesList[0].properties.length < 1)) {
            this.userRolesList.unshift({
                role: null,
                properties: [],
                corporationNumberId: null,
                userRoles: [],
                multiselectBuildings: [],
                propertyFilter: {}
            });
            this.isFormDirty = true;
        } else
            toastr.warning('All User Role details must be filled');
    }

    public remove(index): void {
        if (this.userRolesList.length === 1) {
            this.userService.multiselectBuildings.forEach(item => item.disabled = false);
            this.userRolesList = [];
        } else {
            this.userRolesList[index].properties.forEach(propItem => {
                const match = this.userService.multiselectBuildings.find(item => propItem.id == item.id);
                if (match)
                    match.disabled = false;
            });
            this.onPropertySelect();
            this.userRolesList.splice(index, 1);
        }

        this.isFormDirty = true;
    }

    onCorporationSelect(event, index) {
        const val = parseInt(event.trim());
        const listRoles = this.filterRoles(val);
        this.userRolesList[index].corporationNumberId = val;
        this.userRolesList[index].userRoles = listRoles;
        this.userRolesList[index].propertyFilter = {corporationNumberId: val};
        this.userRolesList[index].multiselectBuildings = this.userService.multiselectBuildings.filter(b => b.corporationNumber == val && !b.disabled);
        this.userRolesList[index].properties = [];
        this.userRolesList[index].role = listRoles.length ? listRoles[0].id : null;
        if (this.userRolesList[index].role !== null)
            this.userRolesList[index].roleName = listRoles[0].name;
        this.userRolesList[index].corporationName = this.userService.corporationNumberListForSearchSelect.find(c => c.value == event).optionText;
    }

    filterRoles(val): UserRole[] {
        return this.userService.userRoles.filter(role => role.corporationNumberId == val) || [];
    }

    onRoleSelect(event, index) {
        this.userRolesList[index].role = parseInt(event.target.value.trim());
        const selectedRole: UserRole = this.userRolesList[index].userRoles.find(r => r.id == this.userRolesList[index].role);
        this.userRolesList[index].roleName = selectedRole ? selectedRole.name : '';
    }

    onPropertySelect(data?) {
        let propertiesCount = 0;

        this.userRolesList.forEach(role => {
            propertiesCount += role.properties.length;
            if (role.corporationNumberId)
                role.multiselectBuildings = this.userService.multiselectBuildings.filter(b => b.corporationNumber == role.corporationNumberId && !b.disabled);
        });

        if (propertiesCount == this.userService.multiselectBuildings.length) {
            this.userRolesList = this.userRolesList.filter(role => role.properties.length);
            if (this.userRolesList.length < 1)
                this.addNewRole();
        }
    }

    public onSelect(selectedItem): void {
        setTimeout(() => {
            this.userService.multiselectBuildings.find(item => item.id == selectedItem.id).disabled = true;
            this.onPropertySelect(selectedItem);
        }, 300);
    }

    public onDeselect(selectedItem): void {
        const current = this.userService.multiselectBuildings.find(item => item.id == selectedItem.id);
        if (current)
            current.disabled = false;
        this.onPropertySelect(selectedItem);
    }

    public onSelectAll(selectedItems, index): void {
        let buildings = JSON.parse(JSON.stringify(this.userService.multiselectBuildings.filter(b => b.corporationNumber == this.userRolesList[index].corporationNumberId)));
        buildings.forEach(b => {
            this.userRolesList.forEach(role => {
                const match = role.properties.find(p => p.id == b.id);
                if (match)
                    b.removed = true;
            });
        });
        buildings = buildings.filter(b => !b.removed);
        buildings = buildings.concat(selectedItems);
        this.userRolesList[index].properties = buildings;

        selectedItems.forEach(sl => {
            const match = this.userService.multiselectBuildings.find(item => sl.id == item.id);
            if (match)
                match.disabled = true;
        });
        this.onPropertySelect(selectedItems);
    }

    public onDeselectAll(selectedItems, index): void {
        let buildings = this.userService.multiselectBuildings.filter(b => b.corporationNumber == this.userRolesList[index].corporationNumberId);
        buildings.forEach(b => {
            this.userRolesList.forEach(role => {
                const match = role.properties.find(p => p.id == b.id);
                if (match)
                    b.removed = true;
            });
        });
        buildings = buildings.filter(b => !b.removed);
        buildings.forEach(b => {
            const match = this.userService.multiselectBuildings.find(msb => msb.id == b.id);
            if (match)
                match.disabled = false;
        });
        this.onPropertySelect(selectedItems);
    }

    addNewRoleDisabled() {
        return !this.userRolesList[0].corporationNumberId || this.userRolesList[0].userRoles.length < 1 || this.userRolesList[0].properties.length < 1;
    }

    getCurrentAccountType() {
        const accountData = JSON.parse(localStorage.getItem('userData'));
        this.isSuperAdmin = accountData.userType === 'super_admin';
    }

    resetPhones(phones) {
        this.itemData.phones = phones;
    }

    allUserRoleDetailsAreFilled(): boolean {
        let allDetailsFilled = true;
        this.userRolesList.forEach((role, index) => {
            if (index != 0 && (role.corporationNumberId === null || role.role === null ||
                !role.userRoles || role.userRoles.length < 1 || !role.properties || role.properties.length < 1))
                allDetailsFilled = false;
        });
        return allDetailsFilled;
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    validateEmail(email) {
        return email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
    }

    calculateCurrentProgressBarLength(): string {
        if (this.step == 'details' && this.itemData.userType == 'property_manager')
            return '17%';
        if (this.step == 'details' && this.itemData.userType != 'property_manager')
            return '24%';
        else if (this.step == 'roles')
            return '50%';
        else if (this.step == 'summary' && this.itemData.userType == 'property_manager')
            return '84%';
        else if (this.step == 'summary' && this.itemData.userType != 'property_manager')
            return '75%';
    }

    moveToTheNextStep(moveTo): void {
        if (moveTo == 'roles') {
            if (this.allRequiredFieldsAreFilled() && this.validateEmail(this.itemData.email) && this.allPhoneDetailsAreFilled())
                this.step = moveTo;
            else if (!this.allRequiredFieldsAreFilled())
                toastr.warning('All required fields must be filled.');
            else if (!this.validateEmail(this.itemData.email))
                toastr.warning('Email is not in valid format.');
            else if (!this.allPhoneDetailsAreFilled())
                toastr.warning('All phone details must be filled before submitting.');
        } else if (moveTo == 'summary') {
            if (this.step == 'roles' && this.userRolesList[0].corporationNumberId !== null &&
                this.userRolesList[0].role !== null && this.userRolesList[0].properties.length > 0)
                this.addNewRole();

            if ((['super_admin', 'company_admin'].includes(this.itemData.userType) || this.userRolesList.length > 1) &&
                this.allRequiredFieldsAreFilled() && this.allPhoneDetailsAreFilled() &&
                (['super_admin', 'company_admin'].includes(this.itemData.userType) || this.allUserRoleDetailsAreFilled()) && this.validateEmail(this.itemData.email))
                this.step = moveTo;
            else if (!this.allRequiredFieldsAreFilled())
                toastr.warning('All required fields must be filled.');
            else if (!this.validateEmail(this.itemData.email))
                toastr.warning('Email is not in valid format.');
            else if (this.itemData.userType == 'property_manager' && this.userRolesList.length < 2)
                toastr.warning('User Roles list must not be empty.');
            else if (this.itemData.userType != 'super_admin' && !this.allUserRoleDetailsAreFilled())
                toastr.error('You should fill all user role details');
            else if (!this.allPhoneDetailsAreFilled())
                toastr.warning('All phone details must be filled before submitting.');
        } else
            this.step = moveTo;
    }

    getCompanyById(id) {
        const match = this.userService.companies.find(c => c.id == id);
        return match ? match.name : '';
    }

    isContinueButtonDisabled(step): boolean {
        // if(step == 'details') {
        //     if(!this.data.title)
        //         isDisabled = true;
        // } else if(step == 'roles') {
        //     if(!this.data.conditionDefinition.value || !this.data.conditionDefinition.name ||
        //         !this.data.conditionField || !(/^[0-9]*$/.test(this.data.conditionDefinition.value)))
        //         isDisabled = true;
        // } else if(step == 'notification') {
        //     if(!this.data.subject || !this.data.template)
        //         isDisabled = true;
        // }
        return false;
    }

    allRequiredFieldsAreFilled() {
        return this.itemData.fullName && this.itemData.email;
    }

    allPhoneDetailsAreFilled() {
        let valid = true;

        this.itemData.phones.forEach(p => {
            if (!p.phone)
                valid = false;
        });

        return valid;
    }

    getUserTypeById(id) {
        const match = this.userTypes.find(c => c.id == id);
        return match ? match.name : '';
    }

    @HostListener('document:change', ['$event'])
    onChange() {
        this.isFormDirty = true;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.close(), 100);
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/user/modal/modal.component.ts